import axiosInstance from "./axiosInstance";
import { uploadFile } from "./uploadService";
import { getUploadDomain } from "../utils/env";
import { logImageCompressError } from "../utils/sensors";
import { compressFile } from "../utils/compress/index";
import { getWebpSupported } from "@voghion/fe-util";
import { canvasSupportsWebp } from "../utils/webp";

//get 请求
export function getAction(url, parameter, options = {}) {
  return axiosInstance({
    url: url,
    method: "get",
    params: parameter,
    ...options,
  });
}
//post请求
export function postAction(url, parameter, options = {}) {
  return axiosInstance({
    url: url,
    method: "post",
    data: parameter,
    ...options,
  });
}
//put 请求
export function putAction(url, parameter) {
  return axiosInstance({
    url: url,
    method: "put",
    data: parameter,
  });
}
//delet请求
export function deleteAction(url, parameter) {
  return axiosInstance({
    url: url,
    method: "delete",
    params: parameter,
  });
}
//http请求
export function httpAction(url, method, parameter) {
  if (method == "get" || method == "delete")
    return axiosInstance({
      url: url,
      method: method,
      params: parameter,
    });
  else
    return axiosInstance({
      url: url,
      method: method,
      data: parameter,
    });
}

const extensionMap = new Map([
  ["image/jpeg", "jpg"],
  ["image/webp", "webp"],
  ["image/png", "png"],
]);

// 上传
export async function handleUploadFile(file) {
  let compressError = null;
  if (file.type.startsWith("image/")) {
    if (!file.compressed) {
      const isDng = file.type.includes("dng");
      // 如果是图片，压缩后再上传，同时解决 dng 图片在 pc 端无法查看的问题
      const supportWebp = getWebpSupported();
      const canvasWebp = canvasSupportsWebp();
      const shouldUseWebp = supportWebp && canvasWebp
      try {
        const lib = await import("compressorjs");
        const Compressor = lib.default || lib;
        await new Promise((resolve, reject) => {
          new Compressor(file.blob, {
            quality: 0.7, // 输出图像的质量
            maxWidth: 2560, // 最大宽度
            maxHeight: 2560, // 最大高度
            mimeType: isDng ? 'image/jpeg' : (shouldUseWebp ? 'image/webp' : 'image/jpeg'), //输出图像的 MIME 类型
            convertTypes: ['image/png', 'image/x-adobe-dng', 'image/heic', 'image/jpeg'],
            convertSize: 0, // 默认值为5000000（5MB）,Infinity表示禁用
            // convertSize 与 convertTypes 配合使用，只有同时满足文件类型在 convertTypes 列表中且文件大小超过 convertSize 阈值时，才会触发转换操作
            success(result) {
              const compressionInfo = {
                原始类型: file.type,
                原始大小: `${(file.size / 1024 / 1024).toFixed(2)} MB (${(file.size / 1024).toFixed(2)} KB)`,
                压缩后类型: result.type,
                压缩后大小: `${(result.size / 1024 / 1024).toFixed(2)} MB (${(result.size / 1024).toFixed(2)} KB)`,
              };
              console.log('图片压缩信息:', compressionInfo);
              if (result.size > 10000) {
                // 压缩后如果小于10k,用原图显示
                file.blob = result
                file.type = result.type
                file.size = result.size
                const newExtension = extensionMap.get(result.type)
                if (newExtension) {
                  file.extension = newExtension;
                }
              } else {
                compressError = new Error("image compress too small");
              }
              file.compressed = true
              resolve(true)
            },
            error(err) {
              reject(err);
            },
          });
        });
      } catch (err) {
        compressError = err;
      }
    } else {
      console.log(`已压缩，不再重复压缩~ 当前文件大小 ${file.blob.size / 1024 } KB`)
    } 
  } else if (file.type.startsWith("video/")) {
    if (!file.compressed) {
      try {
        const res = await compressFile(file.blob);
        if (res && res.blob) {
          file.blob = res.blob;
          file.compressed = true;
        }
      } catch (error) {
        console.log("压缩失败，原视频继续上传");
        console.log("compressFile error", error);
      }
    } else {
      console.log(`已压缩，不再重复压缩~ 当前文件大小 ${file.blob.size / 1024 / 1024} MB`)
    }
  }
  let url = "";
  return uploadFile(file, getUploadDomain())
    .then((res) => {
      url = res.data;
      return res;
    })
    .finally(() => {
      if (compressError) {
        logImageCompressError({
          source_file: `type: ${file.type} size: ${file.size} name:${file.name} extension:${file.extension} url:${url}`,
          description: compressError.message,
        });
      }
    });
}
